<template>
    <div class="mx-auto lg:mx-0">
      <p class="mt-6 text-base/8 text-gray-600">We have the training and connections</p>
      <h2 class="text-pretty text-4xl font-semibold tracking-tight text-gray-900">Our partners and associations</h2>
    </div>
</template>
